var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthorized)?_c('iframe',{staticClass:"chat-container",attrs:{"id":"group-management","src":_vm.chatUrl}}):_c('div',{staticClass:"unauthorized-container"},[_c('div',[_vm._v("ไม่มีสิทธิ์เข้าใช้งาน Ruejai Chat")]),_vm._v(" "),_c('div',[_vm._v("ติดต่อผู้ดูแลระบบหากคิดว่าเป็นข้อผิดพลาด")])])
}
var staticRenderFns = []

export { render, staticRenderFns }